import { render, staticRenderFns } from "./4pps.vue?vue&type=template&id=1fa6d097&scoped=true"
import script from "./4pps.vue?vue&type=script&lang=js"
export * from "./4pps.vue?vue&type=script&lang=js"
import style0 from "./4pps.vue?vue&type=style&index=0&id=1fa6d097&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa6d097",
  null
  
)

export default component.exports